import bodyUWithModules from '../../components/withModules';
import courseWrapper from '../../components/courseWrapper';

const navigations = [courseWrapper, bodyUWithModules];

export default navigations;
